import { Wrench } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { StatusPageShell } from '@/components/common/StatusPageShell'

export default function MaintenancePage() {
  return (
    <StatusPageShell>
      <div role="status">
        <Wrench className="size-5 text-text-muted" aria-hidden="true" />
        <h1 className="mt-3 text-lg font-semibold text-text">Server under maintenance</h1>
        <p className="mt-1 text-text-secondary">We are making improvements and will be back shortly. Your work is saved, and no action is needed.</p>
      </div>
      <Button onClick={() => window.location.reload()}>Try again</Button>
    </StatusPageShell>
  )
}
